import { BaseSchedule } from "./BaseSchedule";

export interface Resource {
    capacity: number;
    count: number;
    createdAt?: any;
    createdBy: { id: ID; type?: ResourceCreatedBy };
    id: ID;
    name: string;
    schedules?: BaseSchedule[];
    seller: ID;
    type: ResourceType;
    availableCount?: number;
    unit?: { id: ID };
}

export enum ResourceType {
    GUIDE = "guide",
    EQUIPMENT = "equipment",
}
export interface CreateResource {
    count: number;
    schedules?: BaseSchedule[];
    seller: { id: ID };
    name: string;
    capacity: number;
}

export enum ResourceCreatedBy {
    SELLER = 1,
    TRAVELER = 2,
    ZOOM = 3,
}
